module.exports = __webpack_public_path__ + "img/guinea-bissau.396d6bbb.svg";